import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './FormFieldTooltip.scss';
/**
 * @component FormFieldTooltip
 * @since 1.0.0
 */
export function FormFieldTooltip(props) {
    const { style, title, picto } = Object.assign({ style: 'normal', picto: 'info-circle' }, props);
    const [focused, setFocused] = useState(false);
    /**
     * @function onClick
     * @since 1.0.0
     */
    function onClick() {
        setFocused(!focused);
    }
    /**
     * @function onMouseEnter
     * @since 1.0.0
     */
    function onMouseEnter() {
        setFocused(true);
    }
    /**
     * @function onMouseLeave
     * @since 1.0.0
     */
    function onMouseLeave() {
        setFocused(false);
    }
    const className = classNames('form-field-tooltip', 'form-field-tooltip--' + style, { 'form-field-tooltip--is-focused': focused }, props.className);
    return (React.createElement("div", { className: className, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        React.createElement("div", { className: "form-field-tooltip-head" },
            React.createElement(Icon, { className: "form-field-tooltip-picto", value: picto })),
        React.createElement("div", { className: "form-field-tooltip-body" },
            React.createElement(Text, { className: "form-field-tooltip-title", value: title }))));
}
